import React, { useEffect, useState } from 'react';
import {
    BodyLargeEmphasized,
    BodySmallRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Input,
    Spinner,
    XStack,
    YStack,
} from 'smoothie';

import { GroveSimpleModal } from '../../common/components/GroveSimpleModal';

interface MoneyMapRenameModalProps {
    isOpen: boolean;
    onClose: () => void;
    modalTitle: string;
    currentTitle: string;
    isSaving: boolean;
    onSave: (title: string) => Promise<boolean>;
}

export const MoneyMapRenameModal = ({
    isOpen,
    onClose,
    modalTitle,
    currentTitle,
    isSaving,
    onSave,
}: MoneyMapRenameModalProps) => {
    const [draftTitle, setDraftTitle] = useState(currentTitle);

    useEffect(() => {
        if (isOpen) {
            setDraftTitle(currentTitle);
        }
    }, [isOpen, currentTitle]);

    const canSave =
        draftTitle.length > 0 && draftTitle !== currentTitle && !isSaving;

    const handleSave = async () => {
        if (!canSave) {
            return;
        }
        const ok = await onSave(draftTitle);
        if (ok) {
            onClose();
        }
    };

    return (
        <GroveSimpleModal isOpen={isOpen} onClose={onClose} hasCloseButton>
            <YStack
                gap={20}
                paddingTop={8}
                paddingHorizontal={8}
                paddingBottom={8}
                minWidth={440}
            >
                <BodyLargeEmphasized>{modalTitle}</BodyLargeEmphasized>
                <YStack gap={8}>
                    <BodySmallRegular color="$gray800">
                        Money Map name
                    </BodySmallRegular>
                    <Input
                        value={draftTitle}
                        onChangeText={setDraftTitle}
                        placeholder="Money Map"
                        disabled={isSaving}
                    />
                </YStack>
                <XStack justifyContent="flex-end" gap={12}>
                    {isSaving ? (
                        <Spinner />
                    ) : (
                        <Button
                            variant={ButtonVariant.PRIMARY}
                            size={ButtonSize.LARGE}
                            text="Save"
                            disabled={!canSave}
                            width="auto"
                            onPress={() => {
                                void handleSave();
                            }}
                        />
                    )}
                </XStack>
            </YStack>
        </GroveSimpleModal>
    );
};
